export default "__VITE_ASSET__84e2e572__"